import * as Yup from 'yup';

export const buildAccountInvitationDeclineFormInitialValues = () => {
  return {
    message: '',
  };
};

export const buildAccountInvitationDeclineFormValidationSchema = () => {
  return Yup.object().shape({
    message: Yup.string(),
  });
};
